import React from "react";

const StandardFlex = () => (
  <svg
    version="1.1"
    viewBox="0 0 1200 1200"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: "scale(140%)" }} // This keeps it roughly in line with the other standard icons
  >
    <path d="m331.22 932.53c60.141 14.625 121.08-18.234 141.84-76.547l5.625-15.938h242.63l5.625 15.938c20.766 58.312 81.703 91.219 141.84 76.547 52.781-12.844 91.219-63.469 91.219-120.37v-264.37c0-16.688-3.9375-33.375-11.391-48.375l-91.219-182.53c-16.312-32.766-49.312-53.062-85.781-53.062l-435.61 0.046876c-52.922 0-96 43.078-96 96v452.16c0 56.859 38.391 107.53 91.219 120.37zm508.78-44.531c-39.703 0-72-32.297-72-72s32.297-72 72-72 72 32.297 72 72-32.297 72-72 72zm-144-576h75.469c18.234 0 34.688 10.219 42.938 26.531l72.375 144.71c4.7812 9.4688-2.1562 20.766-12.844 20.766h-177.94zm-204 0h156v192h-156zm-204 48c0-26.531 21.469-48 48-48h108v192h-156zm0 192h624v162.37l-32.062-11.391c-13.078-4.6875-26.531-6.9375-39.938-6.9375-50.531 0-96 32.156-113.06 80.062l-5.625 15.938h-242.63l-5.625-15.938c-17.062-47.859-62.391-80.062-113.06-80.062-13.453 0-26.859 2.3906-39.938 6.9375l-32.062 11.391zm72 192c39.703 0 72 32.297 72 72s-32.297 72-72 72-72-32.297-72-72 32.297-72 72-72z" />
  </svg>
);

export default StandardFlex;
